<template>
  <div class="login-wrap">
    <div class="ms-login">
      <div class="ms-title" v-text="pageTitle"></div>
      <el-form :model="param" :rules="rules" ref="login" label-width="0px" class="ms-content">
        <el-form-item prop="username">
          <el-input v-model="param.username" placeholder="请输入用户名">
            <el-button slot="prepend" icon="el-icon-user"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" placeholder="请输入密码" v-model="param.password" @keyup.enter.native="submitForm()" show-password>
            <el-button slot="prepend" icon="el-icon-lock"></el-button>
          </el-input>
        </el-form-item>
        <div class="login-btn">
          <el-button type="primary" @click="submitForm()">登录</el-button>
        </div>
        <!-- <p class="login-tips">Tips : 用户名和密码随便填。</p> -->
      </el-form>
    </div>
    <div class="copyright">
       <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
            陕ICP备2022008881号-1
       </a>
    </div>
  </div>
</template>

<script>
import qs from 'qs';
import { log } from 'util';
export default {
    data: function() {
        return {
            param: {
                // username: 'admin',
                // password: '123456'
                username: '',
                password: ''
            },
            rules: {
                username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
            },
            // 版权信息
            copyRight: '陕ICP备2022008881号',
            // 登录标题
            pageTitle: '雄立服饰后台管理系统',
        };
    },
    created() {
        // this.getSysConfig();
    },
    methods: {
        submitForm() {
            this.$refs.login.validate(valid => {
                if (valid) {
                    // this.$router.push('/home');
                    this.$axios
                        .post('login', {
                            username: this.param.username,
                            password: this.param.password,
                            loginType:'1'
                        })
                        .then(res => {
                            // console.log(res);
                            if (res.data.code == 0) {
                                this.$notify({
                                    title: '成功',
                                    message: '登录成功',
                                    type: 'success'
                                });
                                this.$message.success('登录成功');
                                sessionStorage.setItem('sessionId', res.data.data.sessionId);
                                sessionStorage.setItem('loginName', res.data.data.userInfo.loginName);
                                sessionStorage.setItem('token', res.data.data.authCode);
                                sessionStorage.setItem('userName', res.data.data.userInfo.name);
                                sessionStorage.setItem('userId', res.data.data.userInfo.id);
                                this.$router.push('/');

                            } else {
                                this.$message.error(`${res.data.data}`);
                            }
                        });
                } else {
                    this.$message.error('请输入账号和密码');
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        async getSysConfig() {
            const res = await this.$axios.post('sys/sysConfig/allList');
            if (res.data.code == 0) {
                res.data.data.forEach(item => {
                    if (item.configType == 1) {
                        sessionStorage.setItem('documentTitle', item.configContent);
                    } else if (item.configType == 2) {
                        sessionStorage.setItem('pageTitle', '雄立服饰后台管理系统');
                    } else if (item.configType == 3) {
                        sessionStorage.setItem('copyRight', item.configContent);
                    }
                });
                document.title = sessionStorage.getItem('documentTitle');
                this.copyRight = sessionStorage.getItem('copyRight');
            }
        }
    }
};
</script>

<style scoped>
.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url(../../assets/img/bg.jpg);
    background-size: 100%;
}
.ms-title {
    width: 100%;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: #fff;
    border-bottom: 1px solid #ddd;
}
.ms-login {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 350px;
    margin: -190px 0 0 -175px;
    border-radius: 5px;
    background: rgb(166, 187, 190,.3);
    overflow: hidden;
}
.ms-content {
    padding: 30px 30px;
}
.login-btn {
    text-align: center;
}
.login-btn button {
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
    background-color: #2fa5ff;
    outline: none;
    font-size: 14px;
}
.login-btn .el-button--primary{
    border:none;
}
.login-tips {
    font-size: 12px;
    line-height: 30px;
    color: #fff;
}
.copyright {
    position: absolute;
    bottom: 10px;
    width: 100%;
    font-size: 18px;
    color:black;
    text-align: center;
}
a{
    color: black;
}
a:hover {color:rgba(99, 91, 91, 0.432)} /* 当有鼠标悬停在链接上 */

</style>